import type { OrganizationDetails } from "~vue/appTypes";
import { computed, type ComputedRef, inject, type Ref } from "vue";

export function useNadiaChatRefreshEnabled(): ComputedRef<boolean> {
    const organizationDetails = inject<Ref<OrganizationDetails | null> | undefined>("organization_details", undefined);
    return computed(() => Boolean(organizationDetails?.value?.is_nadia_chat_refresh_enabled));
}
